import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Register from './components/main/Register';
import Recovery from './components/main/Recovery';
import Login from './components/main/Login';
import Dashboard from './components/dashboard/Dashboard';
import Campaign from './components/campaigns/Campaign';
import ClientActivity from './components/users/ClientActivity';
import ClientBalance from './components/users/ClientBalance';
import MessagesSe from './components/messages/MessagesSe';
import MessagesRec from './components/messages/MessagesRec';
import CampDetail from './components/campaigns/CampDetail';
import CampEdit from './components/campaigns/CampEdit';
import Listacamp from './components/campaigns/Listacamp';
import Navbar from './components/navigation/Navbar';
import Users from './components/users/Users';
import Editusers from './components/users/Editusers';
import Newusers from './components/users/Newusers';
import Serverdetail from "./components/servers/Serverdetail";
import Servers from "./components/servers/Servers";
import SimDetail from "./components/sim/SimDetail";
import Newserver from "./components/servers/Newserver";
import Editserver from "./components/servers/Editserver";
import Pagenotfound from "./components/notfound/Pagenotfound";
import CampaignBalance from './components/campaigns/CampaignBalance';
import Log from "./components/campaigns/Log";
import Rusers from "./components/reports/rusers";
import Rcampaigns from "./components/reports/rcampaigns";
import Rbalances from "./components/reports/rbalances";

const initialState = {
  lsd: [],
  logeado: false
}

class App extends Component {

  state = { ...initialState }

  componentWillMount() {
    let ls = JSON.parse(localStorage.getItem("ls")) || null;
    if (ls !== null) {
      this.setState({
        user: ls,
        logeado: true
      })
    }

  }

  componentDidMount() {
  }

  checkLogin = (childdata) => {
    if (childdata) {
      let ls = JSON.parse(localStorage.getItem("ls")) || null;
      this.setState({
        user: ls,
        logeado: true
      })
    }
  }

  logout = () => {
    localStorage.removeItem("ls");
    this.setState({
      user: [],
      logeado: false
    }, () => {
      console.log("bye")
      window.location = window.location.origin;
    })
  }

  render() {
    const { logeado } = this.state
    return (
      <Router>
        <Navbar />
        <Switch>
          <Route exact path="/" render={(props) => (logeado ? <Dashboard callBackLogout={this.logout} /> : <Login {...props} parentCallBack={this.checkLogin} />)} />
          <Route exact path="/registrarse" render={() => (logeado ? <Dashboard callBackLogout={this.logout} /> : <Register />)} />
          <Route exact path="/recuperar" render={() => (logeado ? <Dashboard callBackLogout={this.logout} /> : <Recovery />)} />
          <Route exact path="/dashboard" render={() => (logeado ? <Dashboard callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/campañas" render={() => (logeado ? <Campaign callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/actividad-del-cliente" render={() => (logeado ? <ClientActivity callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/consulta-de-saldos" render={() => (logeado ? <ClientBalance callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/mensajes-enviados/:pagenum?/:regporpage?" render={() => (logeado ? <MessagesSe callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/mensajes-recibidos/:pagenum?/:regporpage?" render={() => (logeado ? <MessagesRec callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/detalle-campaña/:id" render={() => (logeado ? <CampDetail callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/editar-campaña/:id" render={() => (logeado ? <CampEdit callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/lista-de-campañas" render={() => (logeado ? <Listacamp callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/lista-de-usuarios" render={() => (logeado ? <Users callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/nuevo-usuario" render={() => (logeado ? <Newusers callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/editar-usuario/:id" render={() => (logeado ? <Editusers callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/detalle-servidor/:id" render={() => (logeado ? <Serverdetail callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/servidores/" render={() => (logeado ? <Servers callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/detalle-sim/:id" render={() => (logeado ? <SimDetail callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/nuevo-servidor" render={() => (logeado ? <Newserver callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/editar-servidor/:id" render={() => (logeado ? <Editserver callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/consulta-de-campañas" render={() => (logeado ? <CampaignBalance callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/log-de-campaña/:id" render={() => (logeado ? <Log callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/reportes/usuarios/:id" render={() => (logeado ? <Rusers callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/reportes/campañas/:id" render={() => (logeado ? <Rcampaigns callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/reportes/saldos/:id" render={() => (logeado ? <Rbalances callBackLogout={this.logout} /> : <Redirect to="/" />)} />
          <Route exact path="/404" component={Pagenotfound} />
          <Redirect to="/404" />
        </Switch>
      </Router>






    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js